<template>
<div class="chapter">
<div class="inner_page">
<p class="autor" id="jump_to_top">Julian Hawthorne</p>
<p class="titel">Der verhängnisvolle Brief</p>
<p class="autor">Kriminalroman</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title_page.vue?40ba26ea